import * as React from 'react';
const { useRef } = React;
const h = React.createElement;

export interface UploadProps {
  beforeUpload?: (file: File, fileList: File[]) => boolean | void;
  accept?: string;
  maxCount?: number;
  showUploadList?: boolean;
  onRemove?: (file: File) => void;
  children?: React.ReactNode;
  className?: string;
}

const Upload: React.FC<UploadProps> = function Upload(props) {
  const { beforeUpload, accept, maxCount, children, className = '' } = props;
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);
    files.forEach((file) => {
      if (beforeUpload) {
        const result = beforeUpload(file, files);
        if (result === false) return;
      }
    });
    e.target.value = '';
  };

  return h(
    'div',
    { className },
    h('input', {
      ref: inputRef,
      type: 'file',
      accept,
      multiple: maxCount !== 1,
      className: 'hidden',
      onChange: handleChange,
    }),
    h(
      'div',
      {
        className: 'cursor-pointer',
        onClick: () => inputRef.current && inputRef.current.click(),
      },
      children,
    ),
  );
};

export { Upload };
